import React from "react";
import { Avatar, Col, Row, Space, Table, Tag, Typography } from "antd";
import { useSupporterRefine } from "hook/supporters/useSupporter";
import { SUPPORTER_PERMISSIONS } from "store/string";
import TableRemove from "./table_remove";
import TableEdit from "./table_edit";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterTable = () => {
  // -------------------------- VAR -----------------------------
  const data = useSupporterRefine();

  console.log({ data });
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Họ và tên",
      dataIndex: "email",
      key: "email",
      render: (_, record) => getEmail(record),
    },
    {
      title: "Quyền truy cập",
      dataIndex: "supporters",
      key: "supporters",
      render: (value) => getSupporters(value),
    },
    {
      title: "Thao tác",
      dataIndex: "#",
      key: "#",
      width: 100,
      align: "center",
      fixed: "right",
      render: (_, record) => renderActions({ record }),
    },
  ];

  const renderActions = ({ record }) => {
    return (
      <Space>
        <TableEdit data={record} />
        <TableRemove data={record} />
      </Space>
    );
  };

  const getEmail = (record) => {
    const email = record?.email;
    const fullName = record.fullName;
    const avatar = email?.slice(0, 2);
    return (
      <Space>
        <Avatar size={40}>{avatar}</Avatar>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Typography.Text>{fullName || email}</Typography.Text>
          <Typography.Text type="secondary">{email}</Typography.Text>
        </div>
      </Space>
    );
  };

  const getSupporters = (value) => {
    return (
      <Row>
        {value?.map((item) => {
          const exist = SUPPORTER_PERMISSIONS?.find((c) => c?.value === item);
          const label = exist?.label;
          return (
            <Col key={item}>
              <Tag>{label}</Tag>
            </Col>
          );
        })}
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <div style={{ width: "100%" }}>
      <Table
        scroll={{ x: "max-content" }}
        rowKey={"id"}
        size="small"
        columns={columns}
        dataSource={data || []}
      />
    </div>
  );
};
export default SupporterTable;
